<template>
    <b-button
      type="button"
      size="sm"
      variant="success"
      v-on:click="updatePassword"
      :disabled="disabled"
    >
      <i class="fa fa-plus" ></i> Change
    </b-button>
</template>
<script>
  import {RepositoryFactory} from "../../../services/repositories/RepositoryFactory";

  export default {
    name: 'update-password-button',
    props: {
      userId: {
        type: String,
        required: true,
      },
      newPassword: {
        type: String,
        required: true,
      },
      disabled: {
        type: Boolean,
        default: false,
      }
    },
    methods: {
      updatePassword() {
        this.$emit('click')
        RepositoryFactory
          .get('user')
          .updatePassword(this.userId, this.newPassword, this.$route.query.resetHash)
          .then(
            (response) => (
              this.$emit('success', response.data.data)
            )
          )
          .catch(
            response => (
              this.$emit('error', response.response.errors)
            )
          )
      }
    }
  }
</script>
